import { inject } from '@angular/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAgreement from '../../reducers/agreement/agreement.reducer';


export const selectAgreementState = createFeatureSelector<fromAgreement.State>(
  fromAgreement.agreementFeatureKey
);

export const selectLoadingAgreements = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.loadingAgreements
);

export const selectAgreementEmail = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => "reg-ent@entnet.org"
);

export const selectSearchYear = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.searchYear
);

export const selectAgreementForm = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => ({
        year: state.searchYear
    })
);

export const selectAgreements = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.agreements
);

export const selectShowAgreementTable = createSelector(
    selectAgreementState,
    selectLoadingAgreements,
    (state: fromAgreement.State, loadingAgreements: boolean) => loadingAgreements || !(state.agreements.length == 0 && !loadingAgreements)
);

export const selectDocuSignLoading = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.loadingDocusignCreate || state.loadingDocusignView
);

export const selectSelectedDocumentFile = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.selectedDocumentFile
);

export const selectDocumentUploadProgress = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.uploadProgress
);

export const selectIsDocumentUploading = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.isDocumentUploading
);

export const selectDocumentUploadComplete = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.uploadComplete
);

export const selectDocumentUploadError = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.uploadError
);
export const selectUploadedDocuments = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.uploadedDocuments
);

export const selectLoadingDocuments = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.loadingDocuments
);

export const selectDocumentsError = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.documentsError
);

export const selectHasSelectedFile = createSelector(
    selectSelectedDocumentFile,
    (file) => file !== null
);

export const selectCanUpload = createSelector(
    selectSelectedDocumentFile,
    selectIsDocumentUploading,
    (file, isUploading) => file !== null && !isUploading
);

export const selectIsVoidingAgreement = createSelector(
    selectAgreementState,
    (state: fromAgreement.State) => state.isVoidingAgreement
);